"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getTeam", {
  enumerable: true,
  get: function get() {
    return _getTeam["default"];
  }
});
var _getTeam = _interopRequireDefault(require("./getTeam"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }